import { Schema, stubModel } from './schema';
import { normalizeSchema } from './normalizeSchema';
//
import { user } from './resources/user';
import { account } from './resources/account';
import { workspace } from './resources/workspace';
import { role } from './resources/role';
import { library } from './resources/library';
import { project } from './resources/project';
import { projectMember } from './resources/project-member';
import { share } from './resources/share';
import { contentTreeNode } from './resources/content-tree-node';
import { folder } from './resources/folder';
import { asset } from './resources/asset';
import { metadataCategory } from './resources/metadata-category';
import { metadataValues } from './resources/metadata-value';
import { metadataField } from './resources/metadata-field';
import { workspacePreference } from './resources/workspace-preference';
import { activity } from './resources/activities';
import { contract } from './resources/contract';
import { contractType } from './resources/contractType.ts';
import { download } from './resources/download';
import { privilege } from './resources/privilege';
import { featureFlag } from './resources/featureFlag';
import { tag } from './resources/tag';
import { tagCategory } from './resources/tag-category';
import { exportTargetType } from './resources/export-target-type';
import { exportTarget } from './resources/export-target';
import { exportBatch } from './resources/export-batch';
import { projectTemplate } from './resources/project-template';
import { invitation } from './resources/invitation';
import { contractKeyGroup } from './resources/contract-key-group';
import { contractValue } from './resources/contract-value';
import { changeRequest } from './resources/change-request';
import { searchResult } from './resources/search-result';
import { searchResult2 } from './resources/search-result-2';
import { recipient } from './resources/recipient';
import { properties } from './resources/properties';
import { oauth2 } from './resources/oauth2';
import { exportTargetDefault } from './resources/export-target-default';
import { fileUpload } from './resources/file-upload';
import { fileUpload2 } from './resources/file-upload2';
import { team } from './resources/team';
import { projectTeamMembership } from './resources/project-team-membership';
import { validator } from './resources/validator';
import { validation } from './resources/validation';
import { oauth2Provider } from './resources/oauth2-provider';
import { comment } from './resources/comment';
import { approval } from './resources/approval';
import { renderPreset } from './resources/render-preset';
import { renderBatch } from './resources/render-batch';
import { favorite } from './resources/favorite';
import { url } from './resources/url';
import { snapshot } from './resources/snapshot';
import { transferOwnership } from './resources/transfer-ownership';
import { thumbnail } from './resources/thumbnail';
import { generativeModal } from './resources/generative-model';
import { generation } from './resources/generation';
import { contractKey } from './resources/contract-key';
import { invoice } from './resources/invoice';
import { metadataFieldType } from './resources/metadata-field-type';

// export const USE_UPLOADS_VERSION_2 = JSON.parse(localStorage.getItem('UPLOADS_V2') ?? 'false') || JSON.parse(localStorage.getItem('session::state') ?? sessionStorage.getItem('session::state') ?? 'false')?.session?.workspace?.startsWith('6a5b8a50-071d')

export const USE_UPLOADS_VERSION_2 = true;

export const schema = new Schema(
  normalizeSchema({
    version: [0, 26, 0],
    resources: [
      user,
      account,
      workspace,
      role,
      library,
      project,
      projectMember,
      share,
      contentTreeNode,
      folder,
      asset,
      metadataCategory,
      metadataValues,
      metadataFieldType,
      workspacePreference,
      activity,
      contract,
      contractType,
      download,
      renderPreset,
      renderBatch,
      privilege,
      featureFlag,
      tag,
      tagCategory,
      exportTargetType,
      exportTarget,
      exportBatch,
      exportTargetDefault,
      snapshot,
      invitation,
      projectTemplate,
      contractKeyGroup,
      contractValue,
      contractKey,
      metadataField,
      changeRequest,
      searchResult,
      searchResult2,
      recipient,
      properties,
      oauth2,
      oauth2Provider,
      USE_UPLOADS_VERSION_2 ? fileUpload : fileUpload2,
      team,
      projectTeamMembership,
      validator,
      validation,
      comment,
      approval,
      stubModel('content-tree', 'content-trees'),
      favorite,
      url,
      transferOwnership,
      thumbnail,
      generativeModal,
      generation,
      invoice
    ]
  })
);

export * from './schema';
